export const PRE_IPO_TABS = {
  COMPANIES: 'companies',
  SUPPLY: 'supply',
  DEMAND: 'demand',
  PIPELINE: 'pipeline',
  MY_INVESTMENTS: 'my-investments',
  MY_PIPELINE: 'my-pipeline',
} as const;

export type PreIpoTabKey = (typeof PRE_IPO_TABS)[keyof typeof PRE_IPO_TABS];

export const PRE_IPO_VIEWS = {
  GRID: 'grid',
  LIST: 'list',
} as const;

export type PreIpoView = (typeof PRE_IPO_VIEWS)[keyof typeof PRE_IPO_VIEWS];

export const PRE_IPO_PARAMS = {
  TAB: 'tab',
  VIEW: 'view',
  FOLLOWED: 'followed',
  MINE: 'mine',
} as const;

export type PreIpoCabinet = 'admin' | 'entity';

type PreIpoTab = { key: PreIpoTabKey; label: string };

const CABINET_TABS: Record<PreIpoCabinet, readonly PreIpoTab[]> = {
  admin: [
    { key: PRE_IPO_TABS.COMPANIES, label: 'Companies' },
    { key: PRE_IPO_TABS.SUPPLY, label: 'Supply' },
    { key: PRE_IPO_TABS.DEMAND, label: 'Demand' },
    { key: PRE_IPO_TABS.PIPELINE, label: 'Pipeline' },
  ],
  entity: [
    { key: PRE_IPO_TABS.COMPANIES, label: 'Companies' },
    { key: PRE_IPO_TABS.SUPPLY, label: 'Supply' },
    { key: PRE_IPO_TABS.MY_INVESTMENTS, label: 'My Investments' },
    { key: PRE_IPO_TABS.MY_PIPELINE, label: 'My Pipeline' },
  ],
};

/** The board tab of each cabinet; it needs a grant the other tabs do not. */
export const PIPELINE_TAB_BY_CABINET: Record<PreIpoCabinet, PreIpoTabKey> = {
  admin: PRE_IPO_TABS.PIPELINE,
  entity: PRE_IPO_TABS.MY_PIPELINE,
};

export const getVisiblePreIpoTabs = (
  cabinet: PreIpoCabinet,
  { canViewPipeline }: { canViewPipeline: boolean },
): PreIpoTab[] =>
  CABINET_TABS[cabinet].filter(
    ({ key }) => canViewPipeline || key !== PIPELINE_TAB_BY_CABINET[cabinet],
  );

export const isPreIpoTabKey = (value: string | null): value is PreIpoTabKey =>
  Object.values(PRE_IPO_TABS).includes(value as PreIpoTabKey);
